export default __webpack_public_path__ + "static/media/033-wild animals.96a2df8b.png";